import React from "react";
import { useSwipeable } from "react-swipeable";
import { getDisplayName } from "../../utils/mailUtils";

function MailListItem({
  mail,
  folder,
  selected,
  starredMap,
  onSelectMail,
  onToggleStar,
  isChecked,
  onToggleSelect,
  isMobile = false,
  onStatusChange,
}) {
  const starKey = String(mail.id);
  const isStarred = Object.prototype.hasOwnProperty.call(starredMap, starKey)
    ? Boolean(starredMap[starKey])
    : Boolean(mail.starred);

  const sentAtValue = mail.sentAt || mail.date;
  const formattedDate = sentAtValue
    ? new Date(sentAtValue).toLocaleString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      })
    : "";

  const correspondent =
    folder === "sent"
      ? mail.toName || getDisplayName(mail.to)
      : mail.fromName || getDisplayName(mail.from);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => onToggleStar?.(mail, !isStarred),
    preventDefaultTouchmoveEvent: true,
    trackMouse: false,
  });

  return (
    <div
      {...swipeHandlers}
      className={`mail-list-item ${selected ? "selected" : ""} ${mail.unread ? "unread" : "read"}`}
      onClick={() => onSelectMail?.(mail)}
      style={mail.unread ? { background: '#e6f7ff' } : {}}
    >
      <div className="mail-list-top">

<label
  className="mail-checkbox-label"
  onClick={(e) => e.stopPropagation()}
  style={{ opacity: 1 }}   // ← was hidden via CSS, force visible
>
  <input
    type="checkbox"
    className="mail-select-checkbox"
    checked={Boolean(isChecked)}
    onChange={(e) => onToggleSelect?.(mail.id, e.target.checked)}
    aria-label="Select message"
    style={{ cursor: "pointer", width: 15, height: 15 }}
  />
</label>

        <button
          type="button"
          className={`mail-star-toggle ${isStarred ? "active" : ""}`}
          onClick={(e) => { e.stopPropagation(); onToggleStar?.(mail, !isStarred); }}
        >
          <i className={`fa-${isStarred ? "solid" : "regular"} fa-star`} />
        </button>

        {/* Name — grows to fill space */}
        <span className="mail-list-from">
          <b>{correspondent} </b><br/> {mail.subject || "(No subject)"}</span>

        {/* Right cluster: date only */}
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          flexDirection: "column"
        }}>
          <span className="mail-list-date">{formattedDate}</span>
          {/* Mail status tag on second line, right-aligned */}
          {/* {mail.mailStatus && (
            <span
              className={`mail-status-tag status-${(mail.mailStatus || "na").toLowerCase().replace(/\s/g, "-")}`}
              style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.4 }}
            >
              {mail.mailStatus.toUpperCase()}
            </span>
          )} */}
          {mail.mailStatus && (() => {
  const status = (mail.mailStatus || "").toLowerCase();

  return (
    <div style={{ flexShrink: 0 }}>
      
      {status === "open" && (
        <span style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          background: "#06a03ff5",
          color: "#e9f3e9",
          fontSize: 11, fontWeight: 700,
          padding: "4px 9px",
          borderRadius: 20,
          whiteSpace: "nowrap",
          border: "1px solid rgba(37,99,235,0.3)",
        }}>
          📂 Open
        </span>
      )}

      {status === "in progress" && (
        <span style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          background: "#1463e3",
          color: "#e9f3e9",
          fontSize: 11, fontWeight: 700,
          padding: "4px 9px",
          borderRadius: 20,
          whiteSpace: "nowrap",
          border: "1px solid rgba(245,158,11,0.3)",
        }}>
          🔄 Progress
        </span>
      )}

      {status === "action" && (
        <span style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          background: "#c98f1f",
          color: "#e9f3e9",
          fontSize: 11, fontWeight: 700,
          padding: "4px 9px",
          borderRadius: 20,
          whiteSpace: "nowrap",
          border: "1px solid rgba(239,68,68,0.3)",
        }}>
          ⚠️ Action
        </span>
      )}

      {status === "closed" && (
        <span style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          background: "#50545a",
          color: "#e9f3e9",
          fontSize: 11, fontWeight: 700,
          padding: "4px 9px",
          borderRadius: 20,
          whiteSpace: "nowrap",
          border: "1px solid rgba(34,197,94,0.3)",
        }}>
          ✅ Closed
        </span>
      )}
       {/* {status === "na" && (
        <span style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          background: "#068e95",
          color: "#e9f3e9",
          fontSize: 11, fontWeight: 700,
          padding: "4px 9px",
          borderRadius: 20,
          whiteSpace: "nowrap",
          border: "1px solid rgba(124, 129, 126, 0.3)",
        }}>
          NA
        </span>
      )} */}

    </div>
  );
})()}
        </div>
      </div>
    </div>
  );
}

export default MailListItem;
